var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import { BlobRefType } from '@augloop/types-core';
import { Log, LogCategory } from '@augloop/logging';
import { fetch } from 'cross-fetch';
import { JSOND } from '@augloop/jsond';
import { ErrorResponse } from '@augloop/session-protocol';
function makeRequestForConnectParams(connectParams, options) {
    return __awaiter(this, void 0, void 0, function* () {
        const { authToken, origin, sessionUrl } = connectParams;
        const { body, cv, method, requestUrl } = options;
        const response = yield fetch(requestUrl || sessionUrl, {
            method,
            headers: Object.assign({ Authorization: `Bearer ${authToken}`, 'x-origin': origin, 'x-correlationid': cv }, options.headers),
            body,
        });
        if (response.status !== 200) {
            throw new Error(`Unexpected status code: ${response.status}`);
        }
        return response;
    });
}
const logOperation = (logOp, errorMessage) => {
    if (errorMessage) {
        logOp.resultDescription = errorMessage;
        logOp.success = false;
        Log.error(0x1e42139e /* tag_4q7o4 */, LogCategory.CoreDefault, logOp.stop());
    }
    else {
        Log.info(0x1e42139d /* tag_4q7o3 */, LogCategory.CoreDefault, logOp.stop());
    }
};
export function sendLargeBinaryDataMessage(connectParams, message, logOp, onResponse) {
    let errorResponse;
    void makeRequestForConnectParams(connectParams, {
        headers: {
            'Content-Type': 'application/jsond',
        },
        body: JSOND.serialize(message),
        cv: logOp.cv,
        method: 'POST',
    })
        .then((response) => {
        return response.json();
    })
        .catch((error) => {
        errorResponse = new ErrorResponse({ messageId: message.messageId, error: error.message });
        return undefined;
    })
        .then((responseJson) => {
        logOperation(logOp, errorResponse ? errorResponse.error : undefined);
        onResponse(errorResponse, responseJson);
    });
}
export function fetchBlobFromRef(connectParams, blobRef, onResponse, logOp) {
    const { sessionUrl } = connectParams;
    let err;
    void makeRequestForConnectParams(connectParams, {
        cv: logOp.cv,
        method: 'GET',
        requestUrl: blobRef.refType === BlobRefType.AlCodedLocation ? `${sessionUrl}/blob/${blobRef.value}` : blobRef.value,
    })
        .then((response) => {
        return response.arrayBuffer();
    })
        .then((buffer) => {
        return new Uint8Array(buffer);
    })
        .catch((error) => {
        err = error;
        return undefined;
    })
        .then((data) => {
        logOperation(logOp, err ? err.message : undefined);
        onResponse(err, data);
    });
}
//# sourceMappingURL=blob-utils.js.map